export const REFUND_TYPE = {
  CASH_BACK: 0,
  POINT_BACK: 1
}
export const BACK_TARGET = {
  OWNER: 1,
  OTHER: 2
}